<div class="modal-container">
  <div class="facs-filters-container">
    <div class="inner-container">
      <div class="header">
        <p class="title">Filtros</p>
        <svg class="close-btn" id="fac-close-btn" (click)="clickClose()" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#2A2A2A"/>
        </svg>   
      </div>

      <!-- Data da criação -->
      <div class="time-row">  
        <p class="label">Data e hora da criação</p>
        <div class="date">
          <div class="inputs-row">
            <nz-date-picker 
              class="datepicker-input"
              nzClassName="datepicker" 
              nzDropdownClassName="datepicker-popup"
              nzFormat="dd/MM/yyyy" 
              nzPlaceHolder="- de" 
              [nzDisabledDate]="disabledCreateStartDate" 
              [(ngModel)]="createTime.date.from">
            </nz-date-picker>
            <app-timepicker 
              [(ngModel)]="!createTime.date.from ? '' : createTime.hour.from" [disabled]="!createTime.date.from"
              [placeholder]="'- de'" (selectValue)="createTime.hour.from = $event">
            </app-timepicker>
          </div>
          <div class="inputs-row">
            <nz-date-picker 
              class="datepicker-input"
              nzClassName="datepicker" 
              nzDropdownClassName="datepicker-popup"
              nzFormat="dd/MM/yyyy" 
              nzPlaceHolder="- até" 
              [nzDisabledDate]="disabledCreateEndDate" 
              [(ngModel)]="createTime.date.to">
            </nz-date-picker>
            <app-timepicker 
              [(ngModel)]="!createTime.date.to ? '' : createTime.hour.to" [disabled]="!createTime.date.to"
              [placeholder]="'- até'" (selectValue)="createTime.hour.to = $event">
            </app-timepicker>
          </div>
        </div>
      </div>

      <!-- Data da atualização -->
      <div class="time-row">  
        <p class="label">Data e hora da atualização</p>
        <div class="date">          
          <div class="inputs-row">
            <nz-date-picker 
              class="datepicker-input"
              nzClassName="datepicker" 
              nzDropdownClassName="datepicker-popup"
              nzFormat="dd/MM/yyyy" 
              nzPlaceHolder="- de" 
              [nzDisabledDate]="disabledUpdateStartDate" 
              [(ngModel)]="updateTime.date.from">
            </nz-date-picker>
            <app-timepicker 
              [(ngModel)]="!updateTime.date.from ? '' : updateTime.hour.from" [disabled]="!updateTime.date.from"
              [placeholder]="'- de'" (selectValue)="updateTime.hour.from = $event">
            </app-timepicker>
          </div>
          <div class="inputs-row">
            <nz-date-picker 
              class="datepicker-input"
              nzClassName="datepicker" 
              nzDropdownClassName="datepicker-popup"
              nzFormat="dd/MM/yyyy" 
              nzPlaceHolder="- até" 
              [nzDisabledDate]="disabledUpdateFinalDate"              
              [(ngModel)]="updateTime.date.to">
            </nz-date-picker>
            <app-timepicker 
              [(ngModel)]="!updateTime.date.to ? '' : updateTime.hour.to" [disabled]="!updateTime.date.to" 
              [placeholder]="'- até'" (selectValue)="updateTime.hour.to = $event">
            </app-timepicker>
          </div>
        </div>
      </div>
      
      <!-- Data e hora da distribuição -->
      <div class="time-row">  
        <p class="label">Data e hora da distribuição</p>
        <div class="date">          
          <div class="inputs-row">
            <nz-date-picker 
              class="datepicker-input"
              nzClassName="datepicker" 
              nzDropdownClassName="datepicker-popup"
              nzFormat="dd/MM/yyyy" 
              nzPlaceHolder="- de" 
              [nzDisabledDate]="disabledDistributionStartDate" 
              [(ngModel)]="distributionTime.date.from">
            </nz-date-picker>
            <app-timepicker 
              [(ngModel)]="!distributionTime.date.from ? '' : distributionTime.hour.from" [disabled]="!distributionTime.date.from"
              [placeholder]="'- de'" (selectValue)="distributionTime.hour.from = $event">
            </app-timepicker>
          </div>
          <div class="inputs-row">
            <nz-date-picker 
              class="datepicker-input"
              nzClassName="datepicker" 
              nzDropdownClassName="datepicker-popup"
              nzFormat="dd/MM/yyyy" 
              nzPlaceHolder="- até" 
              [nzDisabledDate]="disabledDistributionEndDate"              
              [(ngModel)]="distributionTime.date.to">
            </nz-date-picker>
            <app-timepicker 
              [(ngModel)]="!distributionTime.date.to ? '' : distributionTime.hour.to" [disabled]="!distributionTime.date.to" 
              [placeholder]="'- até'" (selectValue)="distributionTime.hour.to = $event">
            </app-timepicker>
          </div>
        </div>
      </div>

      <div [formGroup]="filterForm">
        <div class="bottom-options">
          <div class="drop-downs">
            <app-select
              height="115"
              inputHeight="36px"
              field="name"
              sizeList="3"
              showSearch="false"
              placeholder="Temperatura"
              [listItems]="listTemperature"
              [textTitle]="filterForm.get('temp').value ? filterForm.get('temp').value : ''"
              (sendSearch)="filterForm.get('temp').patchValue($event.name)"
              (clearDropDown)="filterForm.get('temp').patchValue(null)">
            </app-select>
            <app-select
              height="115"
              inputHeight="36px"
              field="name"
              sizeList="3"
              showSearch="false"
              placeholder="Vencimento"
              [listItems]="listChanger"
              [textTitle]="filterForm.get('late').value ? filterForm.get('late').value : ''"
              (sendSearch)="filterForm.get('late').patchValue($event.name)"
              (clearDropDown)="filterForm.get('late').patchValue(null)">
            </app-select>
          </div>
        </div>
  
        <div class="checkbox-row">
          <lib-input-checkbox formControlName="isFavorite" class="item-action" id="favorites" name="favorites" label="Favoritas"
          ></lib-input-checkbox>
          <lib-input-checkbox formControlName="corporator" (click)="selectIncorporator()" class="item-action" id="incorporator" name="incorporator" label="É do incorporador"
          ></lib-input-checkbox>
          <lib-input-checkbox formControlName="notCorporator" (click)="selectNotIncorporator()" class="item-action" id="not-incorporator" name="not-incorporator" label="Não é do incorporador"
          ></lib-input-checkbox>
          <lib-input-checkbox formControlName="archived" class="item-action" id="archived" name="archived" label="Facs arquivadas"
          ></lib-input-checkbox>
        </div> 
      </div>         
  </div>

    <div class="bottom-container">
      <div class="bottom-btns">
        <lib-button-tertiary (click)="resetForm()">Limpar tudo</lib-button-tertiary>
        <lib-button-primary (click)="sendFilter()">Aplicar</lib-button-primary>
      </div>
    </div>
  </div>
</div>